import axios from "axios";

class ApiManager {
  constructor() {
    this.baseUrl = `${process.env.VUE_APP_API_URL}`;
  }

  async fetchResults(params) {
    let response = {
      error: false,
      message: ""
    };

    try {
      const queryString = ApiManager.buildQuerySting(params);
      const request = await axios.get(this.baseUrl + queryString);
      if (request.data) {
        response = request.data;
      } else {
        response.error = true;
        response.message = request;
      }
    } catch (error) {
      response.error = true;
      response.message = error;
    }

    return response;
  }

  buildHistoryString = params => {
    let queryString = [];
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value) {
        const param = `${key}=${encodeURIComponent(value)}`;
        queryString.push(param);
      }
    });
    queryString = queryString.join("&");
    return queryString === ""
      ? this.baseUrl
      : `?${queryString ? `&${queryString}` : ""}`;
  };
}

ApiManager.buildQuerySting = params => {
  let queryString = [];
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value != null) {
      const param = `${key}=${encodeURIComponent(value)}`;
      queryString.push(param);
    }
  });
  queryString = queryString.join("&");
  return `?${queryString ? `${queryString}` : ""}`;
};

export default new ApiManager();
